import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import { useCrm } from "./CrmContext";
import { ACTIVITY, ago, when } from "@/lib/crm";

export const ActivityItem = ({ activity, compact = false }) => {
  const { openPerson } = useCrm();
  const meta = ACTIVITY[activity.kind] || ACTIVITY.note;
  const Icon = meta.icon;
  const inbound = activity.direction === "in";
  return (
    <article className={`relative flex gap-3 ${compact ? "border-b border-[#F1F5F9] py-2.5 last:border-0" : "pb-5"}`} data-testid={`activity-${activity.id}`}>
      {!compact && <span className="absolute left-[15px] top-8 h-[calc(100%-24px)] w-px bg-[#E2E8F0]" />}
      <span className="relative grid h-8 w-8 shrink-0 place-items-center rounded-full" style={{ background: `${meta.color}18`, color: meta.color }}><Icon className="h-4 w-4" /></span>
      <div className="min-w-0 flex-1">
        <p className="flex flex-wrap items-center gap-x-2 text-[12px] text-[#64748B]">
          <span className="font-semibold" style={{ color: meta.color }}>{meta.label}</span>
          {activity.direction && <span className={`inline-flex items-center gap-0.5 rounded px-1.5 font-mono text-[10px] uppercase ${inbound ? "bg-[#E11D48]/10 text-[#E11D48]" : "bg-[#F1F5F9]"}`}>{inbound ? <ArrowDownLeft className="h-3 w-3" /> : <ArrowUpRight className="h-3 w-3" />}{inbound ? "Reply" : activity.status || "Logged"}</span>}
          {activity.outcome && <span className="rounded bg-[#F1F5F9] px-1.5 text-[11px]">{activity.outcome}</span>}
          {activity.lead_name && <button type="button" onClick={() => openPerson(activity.lead_id)} className="font-medium text-[#2B8FD6] hover:underline" data-testid={`activity-lead-${activity.id}`}>{activity.lead_name}</button>}
          <span className="ml-auto font-mono text-[10.5px]" title={when(activity.created_at)}>{ago(activity.created_at)}</span>
        </p>
        {activity.subject && <p className="mt-0.5 text-[13px] font-medium">{activity.subject}</p>}
        <p className={`mt-0.5 whitespace-pre-line text-[13px] leading-relaxed ${compact ? "line-clamp-2" : ""} ${inbound ? "rounded-lg bg-[#FFF1F3] px-3 py-2" : ""}`}>{activity.detail}</p>
        {!compact && <p className="mt-1 text-[11px] text-[#94A3B8]">{activity.agent_name}</p>}
      </div>
    </article>
  );
};

const FILTERS = [["all", "All"], ["note", "Notes"], ["call", "Calls"], ["text", "Texts"], ["email", "Emails"], ["web", "Website"], ["appointment", "Appts"]];

export const Timeline = ({ activities, filter, setFilter }) => (
  <div data-testid="person-timeline">
    <div className="mb-4 flex gap-1 overflow-x-auto no-scrollbar" data-testid="timeline-filters">
      {FILTERS.map(([id, label]) => (
        <button key={id} type="button" onClick={() => setFilter(id)} data-testid={`timeline-filter-${id}`}
          className={`shrink-0 rounded-full px-3 py-1 text-[12px] transition-colors ${filter === id ? "bg-[#3A4553] text-white" : "bg-[#F1F5F9] text-[#475569] hover:bg-[#E2E8F0]"}`}>
          {label} <span className="font-mono text-[10px] opacity-70">{id === "all" ? activities.length : activities.filter((a) => a.kind === id).length}</span>
        </button>
      ))}
    </div>
    {activities.filter((a) => filter === "all" || a.kind === filter).map((a) => <ActivityItem key={a.id} activity={a} />)}
    {!activities.length && <p className="py-8 text-center text-[13px] text-[#94A3B8]" data-testid="timeline-empty">No history yet. Log a call, send a text or add a note.</p>}
  </div>
);
